export default "__VITE_ASSET__Df51wHUj__"